'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;
// import { Link } from 'react-router';
// import ECard from '../Common/ECard';

// import { Glyphicon } from 'react-bootstrap';
// import Slider from 'react-slick';
// import Carousel from 'nuka-carousel';

// import { enterprisePrice } from 'helpers/lib';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _localStorage = require('../../../utils/localStorage');

var _support = require('helpers/support');

var _PCard = require('../Common/PCard');

var _PCard2 = _interopRequireDefault(_PCard);

var _reactRedux = require('react-redux');

var _voucher = require('redux/modules/voucher');

var voucherActions = _interopRequireWildcard(_voucher);

var _lodash = require('lodash');

var _reactBootstrap = require('react-bootstrap');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnterpriseMobile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    promotions: state.voucher.promotions,
    promotionsEnterprise: state.voucher.promotionsEnterprise,
    promotionsEnterpriseError: state.voucher.promotionsEnterpriseError,
    toggleEnterpriseJoin: state.voucher.toggleEnterpriseJoin,
    codeToSubmit: state.voucher.codeToSubmit,
    user: state.auth.user
  };
}, (0, _extends3.default)({}, voucherActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(EnterpriseMobile, _Component);

  function EnterpriseMobile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EnterpriseMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnterpriseMobile.__proto__ || (0, _getPrototypeOf2.default)(EnterpriseMobile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      code: '',
      codeSubmit: _this.props.codeToSubmit || '',
      promoEnter: _this.props.promotionsEnterprise || {},
      promoError: _this.props.promotionsEnterpriseError || {},
      promotions: _this.props.promotions,
      showModalInfo: false,
      infoMessage: {
        title: '',
        content: ''
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  // CODE TEST: PA2019_LMDN


  (0, _createClass3.default)(EnterpriseMobile, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // TODO: Lấy coupon doanh nghiệp mà user đã dùng userId
      var codeEnterprise = (0, _localStorage.localStore)().get('codeEnterprise');
      if (codeEnterprise) {
        this.setState({ code: codeEnterprise, codeSubmit: codeEnterprise });
        this.props.submitCodeEnter(codeEnterprise);
      }
    }
    // componentDidMount() {
    // }

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _lodash.isEqual)(this.state.promoEnter, nextProps.promotionsEnterprise)) {
        this.setState({ promoEnter: nextProps.promotionsEnterprise });
      }
      if (this.state.codeSubmit !== nextProps.codeToSubmit) {
        this.setState({
          code: nextProps.codeToSubmit,
          codeSubmit: nextProps.codeToSubmit
        });
      }
      if (!(0, _lodash.isEqual)(this.props.promotionsEnterpriseError, nextProps.promotionsEnterpriseError) && !(0, _lodash.isEmpty)(nextProps.promotionsEnterpriseError)) {
        var err = nextProps.promotionsEnterpriseError;
        this.setState({
          showModalInfo: true,
          infoMessage: { title: 'Lỗi', content: err.message }
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(event) {
      this.setState({ code: event.target.value });
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit() {
      var code = this.state.code;

      if (code) {
        this.props.submitCodeEnter(code);
      }
    }
  }, {
    key: 'closeModalInfo',
    value: function closeModalInfo() {
      this.setState({ showModalInfo: false });
    }
  }, {
    key: 'clearCode',
    value: function clearCode() {
      this.props.removeCodeEnter();
    }
  }, {
    key: 'isUsed',
    value: function isUsed() {
      var user = this.props.user;
      var promoEnter = this.state.promoEnter;

      if (promoEnter && user && promoEnter.campaign && promoEnter.campaign.typeVoucher === 'partner' && promoEnter.userUsed._id === user._id && promoEnter.packageService) {
        return true;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./EnterpriseMobile.scss');
      var _state = this.state,
          _state$promoEnter = _state.promoEnter,
          campaign = _state$promoEnter.campaign,
          packageService = _state$promoEnter.packageService,
          showModalInfo = _state.showModalInfo,
          infoMessage = _state.infoMessage,
          promoEnter = _state.promoEnter;

      var packageServices = campaign ? campaign.packageServices : {};
      var isUsed = this.isUsed.call(this);
      return _react2.default.createElement(
        'div',
        { className: styles.enterprise },
        _react2.default.createElement(
          'div',
          { className: styles.box },
          _react2.default.createElement(
            'div',
            {
              className: styles.lists + ' ' + (packageServices.length === 0 ? styles.none : '')
            },
            isUsed ? packageServices && packageServices.length > 0 && packageServices.map(function (v, i) {
              if (v._id === packageService._id) {
                return _react2.default.createElement(_PCard2.default, {
                  key: 'used_' + i,
                  className: styles.PCard,
                  card: (0, _support.partnerData)(promoEnter, v)
                });
              }
            }) : packageServices && packageServices.length > 0 && packageServices.map(function (v, i) {
              return _react2.default.createElement(_PCard2.default, {
                key: 'all_' + i,
                className: styles.PCard,
                card: (0, _support.partnerData)(promoEnter, v)
              });
            }),
            packageServices.length === 0 && _react2.default.createElement(
              'div',
              null,
              'Kh\xF4ng c\xF3 d\u1ECBch v\u1EE5'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.boxCode },
            _react2.default.createElement(
              'div',
              { className: styles.input },
              _react2.default.createElement('input', {
                type: 'text',
                disabled: this.state.codeSubmit !== '' ? true : false,
                value: this.state.code,
                placeholder: 'Nhập mã ưu đãi',
                onChange: this.handleChange.bind(this)
              }),
              this.state.codeSubmit && _react2.default.createElement('span', { className: styles.vector })
            ),
            this.state.codeSubmit ? _react2.default.createElement(
              'div',
              {
                className: styles.submit + ' ' + styles.remove,
                onClick: this.clearCode.bind(this)
              },
              'X\xF3a m\xE3'
            ) : _react2.default.createElement(
              'div',
              {
                className: styles.submit + ' ' + (this.state.code !== '' && this.state.codeSubmit === '' ? styles.available : ''),
                onClick: this.handleSubmit.bind(this)
              },
              'S\u1EED d\u1EE5ng'
            )
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            onHide: this.closeModalInfo.bind(this),
            show: showModalInfo,
            className: 'enterpriseModal ' + styles.modal
          },
          _react2.default.createElement(
            _reactBootstrap.Modal.Header,
            { closeButton: true },
            _react2.default.createElement(
              'div',
              { className: styles.modalHeader },
              _react2.default.createElement(
                'span',
                { className: styles.tilte },
                infoMessage.title
              )
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Body,
            null,
            _react2.default.createElement(
              'div',
              { className: styles.modalBody },
              infoMessage.content
            )
          )
        )
      );
    }
  }]);
  return EnterpriseMobile;
}(_react.Component), _class2.propTypes = {
  promotions: _react.PropTypes.array,
  submitCodeEnter: _react.PropTypes.func,
  promotionsEnterprise: _react.PropTypes.object,
  promotionsEnterpriseError: _react.PropTypes.object,
  codeToSubmit: _react.PropTypes.string,
  toggleEnterpriseJoin: _react.PropTypes.bool,
  removeCodeEnter: _react.PropTypes.func,
  user: _react.PropTypes.object
}, _temp2)) || _class);
exports.default = EnterpriseMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Enterprise/EnterpriseMobile.js
// module id = 1594
// module chunks = 0